export default "__VITE_ASSET__D1v7nA1G__"